export const getLanguage = ({ state }) => state.languageReducer.currentLang;
